export default class productEnum {
    static MATHLETICS = { id: 1, name: 'Mathletics' };
    static SPELLODROME = { id: 3, name: 'Spellodrome' };
    static INTOSICENCE = { id: 6, name: 'Intoscience' };
    static PHONICS = { id: 8, name: 'Phonics' };
}



// WEBPACK FOOTER //
// ./app/helpers/product-enum.js